type KlaviyoCommand = [string, ...unknown[]];

interface KlaviyoQueue {
  push: (command: KlaviyoCommand) => void;
}

declare global {
  interface Window {
    klaviyo?: KlaviyoQueue;
    _learnq?: KlaviyoQueue;
  }
}

/**
 * klaviyo.js is loaded async (see app/layout.tsx), so it may not be present yet
 * when an event fires. Pushing to a plain array stub is the pattern klaviyo.js
 * expects - it drains any pre-existing _learnq on load, so nothing is lost.
 */
const getKlaviyo = () => {
  if (typeof window === "undefined") return null;
  if (window.klaviyo) return window.klaviyo;
  if (!window._learnq) window._learnq = [] as KlaviyoCommand[];
  return window._learnq;
};

export const klaviyoTrack = (
  event: string,
  properties: Record<string, unknown>,
) => {
  try {
    getKlaviyo()?.push(["track", event, properties]);
  } catch (e) {
    console.error("Klaviyo track failed", e);
  }
};
